import { useCallback, useEffect, useMemo } from 'react'
import useFilterContext from 'components/Filter/context'
import type { FilterStateT } from 'components/Filter/types'
import useSelectedStatesContext from 'pages/AbsencePlanner/contexts/selectedStatesContext'
import type { TaskListProps } from 'redesign/components/templates/ContentLists/TaskList/types'
import { SIDE_MENU_OPTIONS } from 'redesign/components/templates/SideMenu/constants'
import { useFiltersStorageContext } from 'redesign/services/FiltersStorage/useFiltersStorageContext'
import { useSideMenuContext } from 'redesign/services/SideMenu/useSideMenuContext'
import type { UseSideMenuTaskListContentProps } from './types'

export const useSideMenuTaskListContent = ({ onTaskClick, handleFilterChange }: UseSideMenuTaskListContentProps) => {
  const { saveFilters, setName, setFilters } = useFiltersStorageContext()
  const { getName, getFilters, resetFilterPage, getConfiguration } = useFilterContext()
  const configuration = useMemo(() => getConfiguration(), [getConfiguration])
  const formName = getName()
  const { selectedPerson } = useSelectedStatesContext()
  const { page } = useSideMenuContext()
  const contextFilters = useMemo(() => getFilters(), [getFilters])

  const handleTaskClick: TaskListProps['onTaskClick'] = useCallback(
    ({ task }) => {
      onTaskClick({ task })
      saveFilters()
    },
    [onTaskClick, saveFilters],
  )

  const onFilterChange = useCallback(
    (filtersWithDefaults: FilterStateT) => {
      handleFilterChange(filtersWithDefaults)
      setName(getName())
      setFilters(contextFilters)
    },
    [getName, handleFilterChange, contextFilters, setFilters, setName],
  )

  useEffect(() => {
    if (selectedPerson && page === SIDE_MENU_OPTIONS.adminAbsences) {
      resetFilterPage({})
    }
    // Avoid infinite loop by not adding resetFilterPage to the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configuration, selectedPerson, formName])

  return { onFilterChange, handleTaskClick }
}
